import { InfoBar } from "@components/common/info-bar";
import { AddPlanActions } from "@components/plans-table/add-plan-actions";
import { ProjectProfileTab } from "@router/route-params";
import { useAppParams } from "@router/router-helper";
import { ProjectStandaloneSwitch } from "@pages/project-profile/project-standalone-switch";
import { BaseProjectProps } from "@custom-types/base-types";

/** Display Project information in the header of project profile page */
export function ProjectProfileHeader({
  project,
}: BaseProjectProps): React.JSX.Element {
  const { projectProfileTab } = useAppParams();

  return (
    <InfoBar
      shouldReserveActionSpace
      action={
        projectProfileTab === ProjectProfileTab.plans && (
          <AddPlanActions subjectType="PROJECT" subjectId={project.id} />
        )
      }
      items={[
        { label: "Project", content: project.name },
        {
          label: "Subscription",
          content: <ProjectStandaloneSwitch project={project} />,
        },
      ]}
    />
  );
}
